import { Injectable } from '@angular/core';
import { Router, CanActivate} from '@angular/router';
import { AuthService } from './auth.service';
import { ToastrService } from 'ngx-toastr';
@Injectable()
export class StaffAuthGuardService implements CanActivate {
  lang = '';
  urlPrefix= '';
  constructor( public auth: AuthService, public router: Router, 
    private toastr: ToastrService) {
      const href = this.router.url;
      this.lang = href.split('/')[1];
      if(this.lang == 'en' || this.lang == 'cn' || this.lang == 'kr'){ 
        this.urlPrefix = '/' + this.lang ;     
      }
      else {
        this.lang = 'jp';
        this.urlPrefix = '/';
      }
    }
  canActivate(): boolean {
    if (this.auth.isStaffAuthenticated()) {
      return true;
    } else {
      if ( this.lang === 'en') {
        this.toastr.warning('You need to login', 'Info !', { timeOut: 4000 });
      } else {
        this.toastr.warning('ログインが必要です', 'Info !', { timeOut: 4000 });
      }
      this.router.navigate([this.urlPrefix]);
      return false;
    }

  }
}